import { Component } from '@angular/core';
import { ColumnRadioButtonDto, IColumnPk } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-radio-button',
  templateUrl: './ap-column-radio-button.component.html',
})
export class ApColumnRadioButtonComponent extends ApColumnBase<ColumnRadioButtonDto<IColumnPk>> {
  load() {
    // nothing to do
  }

  onChange() {
    if (this.columnInfoDto.OnSelectedCallback) {
      this.columnInfoDto.OnSelectedCallback(this.dataItem);
    }
  }
}
